import { render, staticRenderFns } from "./UsersBlocked.vue?vue&type=template&id=3ef75ab6&"
import script from "./UsersBlocked.vue?vue&type=script&lang=js&"
export * from "./UsersBlocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports